import React from 'react';
import { NeonMessages, DEFAULT_TOAST_MESSAGE_FLOATING_ID } from '@ps-refarch-ux/neon';

/**
 * Renders the Neon toast message container. Mount once at app root or main layout.
 * Wrapped in fixed position container so toasts stay in viewport when page scrolls.
 */
export const ToastContainer: React.FC = () => {
  return (
    <div
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        top: 0,
        pointerEvents: 'none',
        zIndex: 9999,
      }}
    >
      <div style={{ pointerEvents: 'auto' }}>
        <NeonMessages id={DEFAULT_TOAST_MESSAGE_FLOATING_ID} dataType="toast" />
      </div>
    </div>
  );
};
